import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const WentWrong = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg width="165" height="137" viewBox="0 0 165 137" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <defs>
        <linearGradient x1="49.967%" y1="-2.316%" x2="49.967%" y2="101.081%" id="chfaza7wvc">
          <stop offset="0%" stopColor="#FDFEFF" />
          <stop offset="99.64%" stopColor="#ECF0F5" />
        </linearGradient>
        <linearGradient x1="-5.321%" y1="-10.759%" x2="39.003%" y2="37.947%" id="zlum4a3xud">
          <stop offset="0%" stopColor="#BCCBE1" />
          <stop offset="99.42%" stopColor="#FFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient x1="-4.682%" y1="27.06%" x2="34.567%" y2="42.461%" id="kvjel1nz2e">
          <stop offset="0%" stopColor="#E2E8F0" />
          <stop offset="99.42%" stopColor="#FFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient x1="0%" y1="49.999%" x2="100%" y2="49.999%" id="e5p41t5vtf">
          <stop offset="0%" stopColor="#E4002B" />
          <stop offset="96%" stopColor="#A2002B" />
        </linearGradient>
        <filter
          x="-31.8%"
          y="-35.7%"
          width="163.6%"
          height="200%"
          filterUnits="objectBoundingBox"
          id="sec6l8tbfa"
        >
          <feOffset dy="11" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation="11" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.396078431 0 0 0 0 0.478431373 0 0 0 0 0.576470588 0 0 0 0.27 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <path
          d="M121 73.318c0 11.988-9.727 21.676-21.857 21.676H26.145C11.61 95.3 0 83.74 0 69.777 0 55.722 11.713 44.05 26.459 44.782c12.654-39.374 70.592-33.858 75.507 6.87C112.843 53.006 121 62.175 121 73.318z"
          id="nl4b5ckx7b"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          d="M82.5 113c26.233 0 47.5-21.225 47.5-47.5S108.64 18 82.5 18C56.267 18 35 39.225 35 65.5S56.267 113 82.5 113z"
          fill="#EAEEF9"
        />
        <path d="M127 41c2.209 0 4-1.795 4-4s-1.791-4-4-4-4 1.795-4 4 1.791 4 4 4z" fill="#F1F3F9" />
        <path
          d="M136.5 14c1.38 0 2.5-1.116 2.5-2.5S137.88 9 136.5 9s-2.5 1.116-2.5 2.5 1.12 2.5 2.5 2.5zM32.5 47c1.38 0 2.5-1.116 2.5-2.5S33.88 42 32.5 42 30 43.116 30 44.5s1.12 2.5 2.5 2.5zM47 120a5.001 5.001 0 0 0 0-10 5.001 5.001 0 0 0 0 10z"
          fill="#EAEEF9"
        />
        <g transform="translate(22 9)">
          <use fill="#000" filter="url(#sec6l8tbfa)" xlinkHref="#nl4b5ckx7b" />
          <use fill="url(#chfaza7wvc)" xlinkHref="#nl4b5ckx7b" />
        </g>
        <path
          d="M99 95c12.105 0 22-9.835 22-22.005C121 60.835 111.105 51 99 51c-12.106 0-22 9.835-22 21.995C77 85.165 86.894 95 99 95z"
          fill="url(#zlum4a3xud)"
          transform="translate(22 9)"
        />
        <path
          d="M63 96c21.492 0 39-17.449 39-39.005C102 35.45 84.492 18 63 18S24 35.449 24 56.995C24 78.551 41.403 96 63 96z"
          fill="url(#kvjel1nz2e)"
          transform="translate(22 9)"
        />
        <path
          d="m73.883 65.008 1.736-1.743a1.357 1.357 0 0 0 0-1.885 1.354 1.354 0 0 0-1.881 0L72 63.123l-1.738-1.743a1.354 1.354 0 0 0-1.881 0 1.357 1.357 0 0 0 0 1.885l1.736 1.743-1.736 1.742a1.357 1.357 0 0 0 0 1.885c.289.294.578.365.94.365.363 0 .652-.142.941-.365L72 66.893l1.738 1.742c.29.294.578.365.941.365.362 0 .651-.142.94-.365a1.357 1.357 0 0 0 0-1.885l-1.736-1.742zM93.618 65.008l1.955-1.743c.57-.507.57-1.378 0-1.885-.57-.507-1.548-.507-2.118 0L91.5 63.123l-1.955-1.743c-.57-.507-1.547-.507-2.118 0a1.253 1.253 0 0 0 0 1.885l1.955 1.743-1.955 1.742a1.253 1.253 0 0 0 0 1.885c.326.294.652.365 1.06.365.406 0 .732-.142 1.058-.365l1.955-1.742 1.955 1.742c.326.294.652.365 1.058.365.408 0 .734-.142 1.06-.365.57-.506.57-1.378 0-1.885l-1.955-1.742z"
          fill="#989FB0"
        />
        <path
          d="M41.048 32.27c.212-.902 1.059-1.45 1.891-1.216l5.889 1.618c.832.235 1.335 1.156 1.124 2.058-.212.902-1.059 1.45-1.891 1.216l-5.888-1.618c-.833-.235-1.336-1.156-1.125-2.058zM45.673 14.282c.7-.507 1.653-.31 2.129.422l6.934 10.777c.475.732.292 1.735-.408 2.242-.7.497-1.653.31-2.129-.432l-6.934-10.767c-.476-.741-.293-1.745.408-2.242zM59.356 10.033c.912-.179 1.798.393 1.98 1.266l2.632 12.774c.18.872-.413 1.726-1.324 1.894-.913.179-1.798-.393-1.98-1.266l-2.632-12.774c-.18-.872.413-1.726 1.324-1.894z"
          fill="#989FB0"
        />
        <path fill="#989FB0" d="M72 77h21v3H72z" />
        <path d="M85 78h4v5c0 1.1-.895 2-2 2s-2-.9-2-2v-5z" fill="#989FB0" />
        <path
          d="M111.624 27.257a22.532 22.532 0 0 1-1.713 4.736c-1.91 3.45-4.742 6.262-8.298 7.992-3.689 1.85-8.035 2.488-12.448 1.655-10.275-2.109-16.927-11.82-14.753-21.857C76.585 9.747 86.53 3.29 96.87 5.399c3.688.768 6.916 2.498 9.615 4.986 4.479 4.477 6.39 10.804 5.138 16.872z"
          fill="url(#e5p41t5vtf)"
          transform="translate(22 9)"
        />
        <path
          d="m112.008 23.413.001.009.812 9.45C112.89 33.997 113.815 35 115 35c1.185 0 2.11-1.003 2.179-2.128l.812-9.45.001-.01C118.114 21.585 116.82 20 115 20c-1.826 0-3.114 1.65-2.992 3.413zM115 38c-1.665 0-3 1.33-3 3s1.335 3 3 3 3-1.33 3-3-1.335-3-3-3z"
          stroke="#FFF"
          fill="#FFF"
        />
      </g>
    </svg>
  );
};

WentWrong.displayName = 'WentWrong';
